import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_ALL_ACTIONS](state, payload) {
    state.allActions = payload;
  },
  [types.SET_ANSWER](state, payload) {
    state.answer = payload.answers;
    state.summary = { ...payload.summary };
  },
  [types.SET_ANSWER_REVISION](state, payload) {
    state.revisions = payload.answers;
    state.summary = { ...payload.summary };
  },
  [types.SET_ONE_ANSWER](state, payload) {
    state.oneAnswer = payload;
  },
  [types.SET_COSTUMER_NOTIFICATIONS](state, payload) {
    state.costumerNotifications = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/treatments/mutations.js